import React, { useState, useEffect, useRef } from 'react';
import './spin.css';

const fallbackBrands = [
	{ name: 'Yoga Bar', x: 288, y: 132, size: 102 },
	{ name: 'Go Desi', x: 451, y: 292, size: 104 },
	{ name: 'Books Wagon', x: 285, y: 454, size: 110 },
	{ name: 'The Whole Truth', x: 120, y: 274, size: 104 },
];

export function CustomWheel({ prizeList = [], rotating, postSpinHandler }) {
	const [rotation, setRotation] = useState(0);
	const totalRotation = useRef(0);
	const latest = useRef({ prizeList, postSpinHandler });
	latest.current = { prizeList, postSpinHandler };

	useEffect(() => {
		if (!rotating) return;
		const { prizeList: prizes } = latest.current;
		const winnerIndex = prizes.findIndex((prize) => prize.winner);
		if (winnerIndex < 0) return;
		const target = (360 - winnerIndex * 360 / prizes.length) % 360;
		const offset = (target - totalRotation.current % 360 + 360) % 360;
		totalRotation.current += 1440 + offset;
		sessionStorage.setItem('winnerID', prizes[winnerIndex].id);
		setRotation(totalRotation.current);
		const timer = setTimeout(() => latest.current.postSpinHandler?.(), 4000);
		return () => clearTimeout(timer);
	}, [rotating]);

	const brands = prizeList.length ? prizeList : fallbackBrands;
	return (
		<div className="WheelWrapper">
			<div className="CircleBorder">
				<div className="WheelWrapper__Circle" style={{ transform: `rotate(${rotation}deg)` }}>
					{brands.map((prize, i) => {
						const angle = i * 2 * Math.PI / brands.length;
						const fallback = fallbackBrands[i % fallbackBrands.length];
						const brandImage = prize.logo || prize.image;
						const position = {
							left: `${50 + 28 * Math.sin(angle)}%`,
							top: `${50 - 28 * Math.cos(angle)}%`,
						};
						return brandImage ? (
							<img key={prize.id ?? i} src={brandImage}
								alt={prize.spinText || fallback.name}
								className="WheelWrapper__BrandImage" style={position} />
						) : (
							<span key={prize.id ?? i} role="img" aria-label={fallback.name}
								className="WheelWrapper__BrandImage WheelWrapper__BrandImage--Fallback"
								style={{
									...position,
									backgroundSize: `${680 / fallback.size * 100}% ${691 / fallback.size * 100}%`,
									backgroundPosition: `${fallback.x / (680 - fallback.size) * 100}% ${fallback.y / (691 - fallback.size) * 100}%`,
									transform: `translate(-50%, -50%) rotate(${-90 * (i % 4)}deg)`,
								}} />
						);
					})}
				</div>
				<span className="WheelWrapperPointer" aria-hidden="true" />
			</div>
		</div>
	);
}

export default CustomWheel;
